// Server-authored migration metadata. Public attendance input schemas do not accept
// these fields; source:'import' by itself never grants either behavior.
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
const hash = /^[0-9a-f]{64}$/;
const fields = ["id", "employeeId", "type", "occurredAt", "source", "statusId"];

export function importRuntimePolicy(event) {
  const provenance = event?.migrationProvenance;
  const policy = provenance?.runtimePolicy;
  const sourceId = Array.isArray(event?.externalReferences)
    ? event.externalReferences.filter((ref) => ref?.system === "inewi" && ref?.entity === "event") : [];
  if (provenance?.system !== "inewi" || provenance.export?.sourceType !== "official-ui-response" ||
      !hash.test(provenance.export?.sourceSha256 ?? "") || sourceId.length !== 1 ||
      !uuid.test(sourceId[0].sourceId ?? "") || !uuid.test(provenance.sourceEmployeeId ?? "") ||
      event.id !== `inewi_event_${sourceId[0].sourceId}` ||
      event.employeeId !== `inewi_employee_${provenance.sourceEmployeeId}` || event.source !== "import" ||
      !Number.isFinite(Date.parse(event.occurredAt)) ||
      !["WORK_START", "WORK_STOP", "STATUS_START", "STATUS_STOP"].includes(event.type) ||
      policy?.schemaVersion !== 1 || policy.timeBasis !== "source-final" ||
      !["operational", "history-only"].includes(policy.operationalScope) ||
      (policy.operationalScope === "history-only" && event.type !== "WORK_START") ||
      !policy.boundEvent || typeof policy.boundEvent !== "object" || Array.isArray(policy.boundEvent) ||
      fields.some((key) => !Object.hasOwn(policy.boundEvent, key) || policy.boundEvent[key] !== (key === "statusId" ? event[key] ?? null : event[key]))) return null;
  return policy;
}

export function hasFinalSourceTime(event) { return importRuntimePolicy(event) !== null; }
export function isHistoryOnlyEvent(event) { return importRuntimePolicy(event)?.operationalScope === "history-only"; }

// Included in optimistic concurrency fingerprints. Changing a policy invalidates
// pending punches even if the resulting nextType happens to remain unchanged.
export function importRuntimeFingerprint(event) {
  const policy = event?.migrationProvenance?.runtimePolicy;
  if (!policy) return null;
  return [hasFinalSourceTime(event), policy.schemaVersion, policy.timeBasis, policy.operationalScope,
    ...fields.map((key) => policy.boundEvent?.[key])];
}
